module.exports = __webpack_public_path__ + "static/media/nike.1c1dd3b2.svg";